/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-09-30 11:49:03
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-04 16:53:32
 */
const  routerArr = [
    {
      path: "/index/home",
      icon: "ri-home-wifi-fill",
      title: "工作台",
      code:'01',
      isShow:false,
    },
    {
      path: "内容",
      icon: "ri-article-fill",
      title: "内容",
      code:'02',
      isShow:false,
      children: [
        {
          groupName:'稿件管理',
          isShow:false,
          group:[
            { 
              path: "/index/content/all_manuscripts", 
              title: "所有稿件",
              code:'08',
              isShow:false,
              children: [
                { path: "/index/content/manuscripts_edit", title: "编辑稿件", isShow:false,},
              ] 
             },
            { 
              path: "/index/content/column_manuscript", 
              title: "栏目稿件",
              code:'09',
              isShow:false,
              children: [
                { path: "/index/content/column_manuscript/manuscripts_edit", title: "编辑稿件", isShow:false,},
              ] 
            },
            { path: "/index/content/manuscripts", title: "创作稿件",code:'10', isShow:false, },
          ]
        },
        {
          groupName:'新媒体内容',
          isShow:false,
          group:[
            { path: "/index/content/we_chat", title: "微信公众号",code:'11', isShow:false, },
            { path: "/index/content/sina_weibo", title: "新浪微博",code:'12', isShow:false,},
          ]
        },
        {
          groupName:'信息报送',
          isShow:false,
          group:[
            { path: "/index/content/manuscript_submitted", title: "稿件报送",code:'346', isShow:false, },
            { path: "/index/content/manuscript_adopt", title: "稿件采纳",code:'361', isShow:false,},
            { path: "/index/content/platform_solicitation", title: "平台约稿",code:'382', isShow:false,},
            { path: "/index/content/submit_statistics", title: "报送统计",code:'395', isShow:false,},
          ]
        }
      ],
    },
    {
      path: "互动",
      icon: "ri-message-fill",
      title: "互动",
      code:'03',
      isShow:false,
      children: [
        {
          groupName:'站点互动',
          isShow:false,
          group:[
            { 
              path: "/index/interaction/solicitation_survey",
              title: "意见征集",
              code:'41',
              isShow:false,
              children: [
                { path: "/index/interaction/solicitation_survey/add_solicitation", title: "新增征集", isShow:false,},
              ]
            },
            { 
              path: "/index/questionnaire",
              title: "问卷调查",
              code:'292',
              isShow:false,
              children: [
                { path: "/index/questionnaire/details", title: "详情信息", isShow:false,},
                { path: "/index/questionnaire/add", title: "新增问卷", isShow:false,},
              ]
            },
            { 
              path: "/index/interaction/online_interview",
               title: "在线访谈" ,
               code:'42',
               isShow:false,
               children: [
                { path: "/index/interaction/online_interview/add", title: "新增访谈", isShow:false,}, 
                { path: "/index/interaction/online_interview/forbidden_list", title: "禁言名单", isShow:false,},
              ]
              },
            // { path: "/index/interaction/online_message", title: "在线留言", isShow:false, },
            
          ]
        },
        {
          groupName:'智能问答',
          isShow:false,
          group:[
            { 
              path: "/index/interaction/knowledge_base",
              title: "问答库",
              code:'43',
              isShow:false,
              children: [
                { path: "/index/interaction/knowledge_base/add", title: "新增问答", isShow:false,}, 
              ]
            },
            { path: "/index/interaction/unknown_problem", title: "未知问题",code:'44', isShow:false, },
            { path: "/index/interaction/answers_setting", title: "智能问答设置",code:'45', isShow:false, },
            
          ]
        },
        // {
        //   groupName:'领导信箱',
        //   isShow:false,
        //   group:[
        //     { path: "/index/interaction/12345_mailbox", title: "12345信箱",code:'46', isShow:false, },
        //     { path: "/index/interaction/secretary_mailbox", title: "书记信箱",code:'47', isShow:false, },
        //     { path: "/index/interaction/governor_mailbox", title: "州长信箱",code:'48',isShow:false, },
            
        //   ]
        // },
        {
          groupName:'依申请公开',
          isShow:false,
          group:[
            { 
              path: "/index/applicationlist",
              title: "申请清单",
              code:'302',
              isShow:false,
              children: [
                { path: "/index/applicationlist/add", title: "新增申请", isShow:false,},
              ]
            },
            { 
              path: "/index/reporting",
              title: "申请报备",
              code:'425',
              isShow:false,
            },
          ]
        },
       
        
      ],
    },
    {
      path: "配置",
      icon: "ri-folder-settings-fill",
      title: "配置",
      code:'04',
      isShow:false,
      children: [
        {
          groupName:'基础设置',
          isShow:false,
          group:[
            { path: "/index/configure/site_settings", title: "站点设置",code:'69', isShow:false, },
            { 
              path: "/index/configure/column_management",
              title: "栏目管理",
              code:'70',
              isShow:false,
              children: [
                { path: "/index/configure/column_management/add_column", title: "添加栏目", isShow:false,},
              ]
            },
            { 
              path: "/index/configure/substance_model_management",
              title: "内容模型管理",
              code:'71',
              isShow:false,
              children: [
                { path: "/index/configure/substance_model_management/field_management", title: "字段管理", isShow:false,},
              ]
            },
            { path: "/index/friendly_chain", title: "友链管理",code:'72', isShow:false, },
            { 
              path: "/index/configure/template_management", 
              title: "模板管理" ,
              code:'73',
              isShow:false,
              children: [
                { path: "/index/configure/template_management/add_file", title: "新增文件", isShow:false,},
              ]
            },
            { path: "/index/configure/custom_variables", title: "自定义变量",code:'74', isShow:false, },
            { 
              path: "/index/configure/workflow_configuration", 
              title: "工作流配置", 
              code:'75',
              isShow:false,
              children: [
                { path: "/index/configure/workflow_configuration/design_process", title: "流程设计", isShow:false,},
                { path: "/index/configure/workflow_configuration/operation_records", title: "运行记录", isShow:false,},
              ]
            },
            // { path: "/index/configure/message_template_management", title: "消息模板管理",code:'76', isShow:false, },
          ]
        },
        {
          groupName:'新媒体',
          isShow:false,
          group:[
            { path: "/index/configure/weChat_official_account", title: "微信公众号",code:'77', isShow:false, },
            { path: "/index/configure/sina_weibo", title: "新浪微博",code:'78', isShow:false, },
            // { path: "/index/configure/today_headline", title: "今日头条",code:'79', isShow:false, },
            { path: "/index/configure/dithering", title: "抖音",code:'80', isShow:false, },
            
          ]
        },
      ],
    },
    {
      path: "用户",
      icon: "ri-team-fill",
      title: "用户",
      code:'05',
      isShow:false,
      children: [
        {
          groupName:'系统用户',
          isShow:false,
          group:[
            { path: "/index/userManagement/organizational_structure", title: "组织架构",code:'119', isShow:false, },
            { 
              path: "/index/userManagement/role_management", 
              title: "角色管理",
              code:'120',
              isShow:false,
              children: [
                { path: "/index/userManagement/permission_management", title: "权限管理", isShow:false,},
              ] 
            },
            // { path: "/index/userManagement/administrator_management", title: "管理员管理",code:'121', isShow:false, },
          ]
        },
        {
          groupName:'普通用户',
          isShow:false,
          group:[
            { path: "/index/userManagement/user_management", title: "用户管理",code:'122', isShow:false, },
          ]
        },
      ],
    },
    {
      path: "统计",
      icon: "ri-database-2-fill",
      title: "统计",
      code:'06',
      isShow:false,
      children: [
        {
          groupName:'监管考核',
          isShow:false,
          group:[
            { path: "/index/statistics/test_date", title: "指标监测日志",code:'320', isShow:false, },
            { path: "/index/statistics/site_evaluation", title: "站点指标评估",code:'136', isShow:false, },
            { path: "/index/statistics/new_media_monitoring", title: "新媒体监测",code:'137', isShow:false, },
            { path: "/index/statistics/performance_appraisal", title: "绩效考核评分",code:'433', isShow:false, },
          ]
        },
        {
          groupName:'网站统计',
          isShow:false,
          group:[
            { path: "/index/statistics/website_overview", title: "网站概况",code:'134', isShow:false, },
            { path: "/index/statistics/user_analysis", title: "用户分析",code:'135', isShow:false, },
          ]
        },
       
      ],
    },
    {
      path: "系统",
      icon: "ri-settings-4-fill",
      title: "系统",
      code:'07',
      isShow:false,
      children: [
        {
          groupName:'系统管理',
          isShow:false,
          group:[
            // { path: "/index/system/system_settings", title: "系统设置",code:'139', isShow:false, },
            { path: "/index/system/station_group_management", title: "站群管理",code:'140', isShow:false, },
          ]
        },
        {
          groupName:'日志管理',
          isShow:false,
          group:[
            { path: "/index/system/operation_log", title: "操作日志",code:'141', isShow:false, },
          ]
        },
      ],
    },
    
  ]
  export default routerArr;